import React, { ComponentType, PropsWithChildren } from 'react';

export function withProps<P extends object, T>(Component: ComponentType<T>, additionalProps: P) {
  return (({ children, ...props }: PropsWithChildren<any>) => {
    return (
      <Component {...props} {...additionalProps}>
        {children}
      </Component>
    );
  }) as ComponentType<T>;
}
